import React from 'react'
import { Card, Alert, Typography, Steps, Space } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

const { Title, Text, Paragraph } = Typography
const { Step } = Steps

const InvoiceDataHelper = () => {
  return (
    <Card title='How to Delete Invoice Data' style={{ marginTop: 16 }}>
      <Space direction='vertical' style={{ width: '100%' }} size='large'>
        <Alert
          message='Invoice data is managed separately'
          description='Since invoices are part of the main Invoices module, they need to be deleted from there.'
          type='info'
          showIcon
          icon={<InfoCircleOutlined />}
        />

        <div>
          <Title level={4}>Steps to Delete Invoice Data:</Title>
          <Steps direction='vertical' current={-1}>
            <Step
              title='Navigate to Invoices Module'
              description='Go to the main Invoices section in the application'
            />
            <Step
              title='Select Invoices to Delete'
              description='Use the table selection or bulk actions to select invoices'
            />
            <Step
              title='Delete Selected Invoices'
              description='Use the delete action to remove the selected invoices'
            />
            <Step title='Confirm Deletion' description='Confirm the deletion when prompted' />
          </Steps>
        </div>

        <Alert
          message='Alternative: Database Access'
          description={
            <Space direction='vertical'>
              <Paragraph>
                If you have database access, you can delete all invoices for the current entity using:
              </Paragraph>
              <Text code>{'db.invoices.deleteMany({ entityRef: "[current_entity_id]" })'}</Text>
            </Space>
          }
          type='warning'
        />

        <Alert
          message='Impact on Billing Module'
          description='Deleting invoices will automatically remove their corresponding entries in the patient ledger, as they are synced.'
          type='info'
        />
      </Space>
    </Card>
  )
}

export default InvoiceDataHelper
